

import React, { ReactNode } from 'react'

import { RegisterOptions } from 'react-hook-form/dist/types/validator'

import { FormControl, FormControlLabel, Checkbox as MuiCheckBox, Stack, Typography, useTheme } from '@mui/material'
import type { SxProps } from '@mui/system'

import { FieldProps } from './types'





interface CheckBoxProps extends Omit<FieldProps, 'startAdornment'> {
  name: string
  label?: string
  checked?: boolean
  defaultChecked?: boolean
  helperText?: string
  labelAdornment?: ReactNode
  rules?: RegisterOptions
  readOnly?: boolean
  sx?: SxProps
  handleKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  indeterminate?: boolean
  edge?: 'start' | 'end' | false
  tabIndex?: number
  disableRipple?: boolean
  disabled?: boolean
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
}

export const CheckBox = ({
  label,
  name,
  rules,
  register,
  helperText,
  checked = false,
  // formState: { errors },
  readOnly = false,
  defaultChecked,
  sx,
  handleKeyDown,
  onChange,
  indeterminate,
  edge,
  tabIndex,
  disableRipple,
  disabled,
  inputProps,
}: CheckBoxProps) => {

  const theme = useTheme()

  const vera_theme ={
    borderRadius: 2,
    border: `1px solid  ${theme.palette.primary[50]}`,
    fontSize: 16,
    "input": {
      padding: 3,
    },
    "&:hover": {
      border: `1px solid ${theme.palette.brand[600]}` // Change border color when input is hovered
    }
  }

  return (
    <FormControl
    // error={!!errors[name]}
    fullWidth>
        {/* {label && (
        <Stack mb={2} direction="row" spacing={2}>
            <Typography variant="body2">
              {label}
            </Typography>

          {helperText && <FormHelperText>({helperText})</FormHelperText>}
        </Stack>
        )} */}
      <FormControlLabel control={
        <MuiCheckBox
          defaultChecked={defaultChecked}
          checked={checked}
          onChange={onChange}
          indeterminate={indeterminate}
          edge={edge}
          tabIndex={tabIndex}
          disableRipple={disableRipple}
          disabled={disabled}
          inputProps={inputProps}
          sx={{
            pr: 4,
            // VRG-474 — no `color` here. It used to pin both states to `grey[900]`
            // (hsla(228,4%,24%), ~11:1 on white), which OVERRODE the shared `MuiCheckbox`
            // theme and made every form checkbox the boldest control on the page — and
            // meant a fix to the theme could never reach this component. Colour is the
            // theme's job (`packages/ui/theme/theme.ts`); a wrapper only does layout.
          }}

        />
      } label={label} />
    </FormControl>
  )
}
